import { inject, Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastrService = inject(ToastrService);

  // default toast options
  private defaultOptions: Partial<IndividualConfig<any>> = {
    timeOut: 3000,
    progressBar: true,
    enableHtml: true,
    positionClass: 'toast-top-center',
    easing: 'ease-out',
    easeTime: 300,
    tapToDismiss: true,
  };

  // success  options
  private successOptions: Partial<IndividualConfig<any>> = {
    ...this.defaultOptions,
    toastClass: 'toast-success',
    titleClass: 'toast-title',
    messageClass: 'toast-message',
  };

  // error  options
  private errorOptions: Partial<IndividualConfig<any>> = {
    ...this.defaultOptions,
    toastClass: 'toast-error',
    titleClass: 'toast-title',
    messageClass: 'toast-message',
  };

  // info  options
  private infoOptions: Partial<IndividualConfig<any>> = {
    ...this.defaultOptions,
    toastClass: 'toast-info',
    titleClass: 'toast-title',
    messageClass: 'toast-message',
  };

  showSuccess(message: string, title: string = 'Success') {
    this.toastrService.success(message, title, this.successOptions);
  }

  showError(message: string, title: string = 'Error') {
    this.toastrService.error(message, title, this.errorOptions);
  }

  showInfo(message: string, title: string = 'Info') {
    this.toastrService.info(message, title, this.infoOptions);
  }

  showWarning(message: string, title: string = 'Warning') {
    this.toastrService.warning(message, title, this.defaultOptions);
  }
}
